/**
 * Presentación de los enlaces compartidos.
 *
 * Sin JSX para poder probarlo con el ejecutor de Node.
 */

/** ClickHouse manda 'YYYY-MM-DD HH:MM:SS'; el portal manda ISO. Sirven los dos. */
function aFecha(marca: string): Date {
  return new Date(marca.includes('T') ? marca : `${marca.replace(' ', 'T')}Z`);
}

export function fechaCorta(marca: string): string {
  const fecha = aFecha(marca);
  if (Number.isNaN(fecha.getTime())) return marca;
  return fecha.toLocaleString('es-CL', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false });
}

/**
 * Cuánto le queda, en la unidad que le sirve a quien decide si revocarlo.
 *
 * «Vence 30-08-2026 07:41» obliga a restar mentalmente contra el día de hoy.
 * Lo que alguien quiere saber mirando una lista es si esto sigue vivo mañana.
 */
export function describirVigencia(expira: string, ahora = Date.now()): string {
  const restanteMs = aFecha(expira).getTime() - ahora;
  if (Number.isNaN(restanteMs)) return expira;
  if (restanteMs <= 0) return 'vencido';

  const horas = Math.floor(restanteMs / 3_600_000);
  if (horas < 1) return 'vence en menos de una hora';
  if (horas < 24) return `vence en ${horas} ${horas === 1 ? 'hora' : 'horas'}`;

  const dias = Math.round(horas / 24);
  return `vence en ${dias} ${dias === 1 ? 'día' : 'días'}`;
}
